var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrationRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.488 1.42151C11.5586 -0.473836 14.228 -0.473836 15.2986 1.42151L15.3006 1.42505L25.4364 19.5599C26.4485 21.3925 25.2158 23.8 23.0188 23.8H2.78392C0.599933 23.8 -0.670444 21.4192 0.368104 19.5567L10.4857 1.42558L10.488 1.42151ZM12.0562 2.30499C12.0559 2.30559 12.0556 2.30618 12.0552 2.30678L1.94021 20.4334C1.94017 20.4334 1.94026 20.4333 1.94021 20.4334C1.52675 21.1752 2.06346 22 2.78392 22H23.0188C23.7259 22 24.2679 21.1698 23.8616 20.4317C23.8613 20.4312 23.861 20.4307 23.8607 20.4302L13.7314 2.30678C13.7311 2.30625 13.7308 2.30572 13.7305 2.30519C13.3486 1.63167 12.4382 1.6316 12.0562 2.30499Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.898 6C13.3951 6 13.798 6.40294 13.798 6.9V15.9C13.798 16.3971 13.3951 16.8 12.898 16.8C12.401 16.8 11.998 16.3971 11.998 15.9V6.9C11.998 6.40294 12.401 6 12.898 6Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8979 19.8999C13.4502 19.8999 13.8979 19.4522 13.8979 18.8999C13.8979 18.3476 13.4502 17.8999 12.8979 17.8999C12.3457 17.8999 11.8979 18.3476 11.8979 18.8999C11.8979 19.4522 12.3457 19.8999 12.8979 19.8999Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrationRoom);
export default __webpack_public_path__ + "static/media/arbitration-room.fcf4ee45740b1f94c714b78a584ea002.svg";
export { ForwardRef as ReactComponent };